module.exports = __webpack_public_path__ + "static/media/AV_logo.78508d67.png";